export interface CampaignAttribution {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  gclid?: string;
}

function pickParam(params: URLSearchParams, key: string): string | undefined {
  const value = params.get(key)?.trim() ?? '';
  return value ? value.slice(0, 200) : undefined;
}

export function readCampaignAttribution(search = location.search): CampaignAttribution {
  const params = new URLSearchParams(search);
  return {
    utmSource: pickParam(params, 'utm_source'),
    utmMedium: pickParam(params, 'utm_medium'),
    utmCampaign: pickParam(params, 'utm_campaign'),
    gclid: pickParam(params, 'gclid'),
  };
}
